import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

function VerseDisplay({ isSearching, searchResults, handleSearchResultClick, verses, highlightedVerse, verseRefs, searchQuery, handleVerseClick }) {

    const highlightText = (text, query) => {
        if (!query) {
            return text;
        }
        const parts = text.split(new RegExp(`(${query})`, 'gi'));
        return (
            <span>
                {parts.map((part, i) =>
                    part.toLowerCase() === query.toLowerCase() ? (
                        <span key={i} className="highlighted">{part}</span>
                    ) : (
                        part
                    )
                )}
            </span>
        );
    };

    return (
        <div style={{ marginTop: '20px' }}>
            {isSearching ? (
                <div style={{ textAlign: 'left' }}>
                    {searchResults.map((verse, index) => (
                        <Card key={`${verse.book.id}-${verse.chapter}-${verse.verse}`} className="search-result" onClick={() => handleSearchResultClick(verse)} style={{ marginBottom: '10px' }}>
                            <CardContent>
                                <Typography variant="h6"><span className="search-result-number">{index + 1}</span> {verse.book.name} {verse.chapter}:{verse.verse}</Typography>
                                <Typography dangerouslySetInnerHTML={{ __html: verse.highlighted_text }}></Typography>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            ) : (
                <div style={{ columnCount: 1, columnGap: '40px', textAlign: 'left' }}>
                    {verses.map(verse => (
                        <p
                            key={verse.verse}
                            ref={el => verseRefs.current[verse.verse] = el}
                            className={verse.verse === highlightedVerse ? 'highlighted' : ''}
                        >
                            <strong onClick={() => handleVerseClick(verse)} className="verse-number">{verse.verse}</strong> {highlightText(verse.text, searchQuery)}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
}

export default VerseDisplay;